/** Teal primary action — Save, Update, Approve, Revert. Same in light and dark mode. */
export const PRIMARY_BUTTON_CLASS =
    "bg-sidebar-primary text-white hover:bg-sidebar-primary/90 " +
    "border border-sidebar-primary " +
    "focus-visible:ring-2 focus-visible:ring-sidebar-primary focus-visible:ring-offset-2 " +
    "dark:focus-visible:ring-offset-gray-800";

/** Alias — modal/page primary actions use the same teal in both themes. */
export const PRIMARY_ACTION_BUTTON_CLASS = PRIMARY_BUTTON_CLASS;
